import { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  NEW_EXTERNAL_ORDER_EVENT,
  useExternalOrders,
} from '@/hooks/useExternalOrders';
import { ExternalOrdersModal } from '@/components/ExternalOrders/ExternalOrdersModal';

export const NotificationsButton = () => {
  const {
    isFeatureEnabled,
    pendingOrders,
    activeOrders,
    pendingCount,
    activeCount,
    refreshOrders,
  } = useExternalOrders();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleNewOrder = () => {
      setIsOpen(true);
    };
    window.addEventListener(NEW_EXTERNAL_ORDER_EVENT, handleNewOrder);
    return () => window.removeEventListener(NEW_EXTERNAL_ORDER_EVENT, handleNewOrder);
  }, []);

  if (!isFeatureEnabled) return null;

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="default"
        className="relative h-10 touch-manipulation px-3"
        onClick={() => {
          void refreshOrders();
          setIsOpen(true);
        }}
        aria-label="External orders"
      >
        <Bell className="h-4 w-4" />
        {pendingCount > 0 && (
          <Badge
            variant="destructive"
            className="absolute -right-2 -top-2 flex h-5 min-w-5 items-center justify-center p-0 px-1 text-xs"
          >
            {pendingCount}
          </Badge>
        )}
      </Button>
      <ExternalOrdersModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        pendingOrders={pendingOrders}
        activeOrders={activeOrders}
        pendingCount={pendingCount}
        activeCount={activeCount}
      />
    </>
  );
};
